/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicServiceAccountDelete extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicServiceAccountDelete");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicServiceAccountDelete.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicServiceAccountDelete>): BackgroundJobPayloadForPeriodicServiceAccountDelete {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicServiceAccountDelete(), model);
        BackgroundJobPayloadForPeriodicServiceAccountDelete.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicServiceAccountDelete>): BackgroundJobPayloadForPeriodicServiceAccountDelete {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicServiceAccountDelete.newInstance(<BackgroundJobPayloadForPeriodicServiceAccountDelete> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicServiceAccountDelete) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicServiceAccountDelete.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicServiceAccountDelete): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicServiceAccountDelete.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
